import type { InspectionKind, ItemCondition } from '@myrentalmate/api-client';

type ChipColor = 'default' | 'success' | 'warning' | 'error';

export const KIND: Record<InspectionKind, string> = {
  move_in: 'Move-in',
  move_out: 'Move-out',
  periodic: 'Periodic',
};

export const CONDITION: Record<ItemCondition, { label: string; color: ChipColor }> = {
  good: { label: 'Good', color: 'success' },
  fair: { label: 'Fair', color: 'default' },
  poor: { label: 'Poor', color: 'warning' },
  damaged: { label: 'Damaged', color: 'error' },
  na: { label: 'N/A', color: 'default' },
};

/** Items in the order given, under their area's heading. */
export function byArea<Item extends { area: string }>(items: Item[]): [string, Item[]][] {
  const areas = new Map<string, Item[]>();
  for (const item of items) areas.set(item.area, [...(areas.get(item.area) ?? []), item]);
  return [...areas];
}
